<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useAuthStateStore } from "../../stores/Utils/auth/AuthState";
import ProfileCard from "./ProfileCard.vue";
import Popover from "@/components/Reusables/Popover/Popover.vue";

const props = defineProps<{
  lCAdaIsShown: boolean;
  isExpanded: boolean;
}>();
const authState = useAuthStateStore();
const { isAuthenticated, user } = storeToRefs(authState);

const emits = defineEmits(["toggleLCAda"]);

const handleToggleLCAda = (shown: boolean) => {
  emits("toggleLCAda", shown);
};
</script>

<template>
  <Popover
    placement="right-end"
    teleport
    aria-label="Profile menu">
    <template #trigger="{ toggle, isOpen }">
      <button
        v-if="isAuthenticated"
        id="profile-picture"
        type="button"
        data-cy="profile-settings"
        :aria-expanded="isOpen"
        aria-haspopup="dialog"
        aria-label="Profile menu"
        class="focus-ring interactive-active gap-px-12 text-type-default duration-fast hover:bg-app-blue-200/30 ease-standard rounded-8 flex h-8 w-full items-center overflow-hidden px-2.5 text-left whitespace-nowrap transition-colors"
        @click="toggle">
        <img
          :key="user?.id"
          :src="user?.profilePictureUrl || undefined"
          class="shrink-0 rounded-full object-cover"
          :class="isExpanded ? 'h-7 w-7' : 'h-5 w-5'"
          alt="profile-picture" />
        <span
          :class="[
            't-small-bold duration-fast ease-standard min-w-0 flex-1 truncate text-inherit transition-opacity will-change-[opacity]',
            isExpanded ? 'opacity-100' : 'opacity-0',
          ]"
          aria-hidden="true">
          {{ user?.name }}
        </span>
      </button>
    </template>

    <template #default="{ close }">
      <ProfileCard
        data-cy="profile-card"
        :l-c-ada-is-shown="props.lCAdaIsShown"
        @hide-profile-card="close"
        @toggle-l-c-ada="handleToggleLCAda" />
    </template>
  </Popover>
</template>
